<template>
    <div>
        <div class="flex flex-col gap-4 items-center justify-center mb-5">
            <div class="relative w-full">
                <a
                    class="w-full px-4 py-3 flex items-center gap-4 hover:opacity-50 transition-opacity rounded shadow border border-slate-200 font-semibold text-slate-800"
                    href="/login/facebook"
                >
                    <span class="text-[#5e73df]">
                        <svg
                            width="23"
                            height="23"
                            viewBox="0 0 23 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                id="path14"
                                d="M22.0418 11.5625C22.0418 5.74046 17.3222 1.0208 11.5002 1.0208C5.67816 1.0208 0.958496 5.74046 0.958496 11.5625C0.958496 16.8241 4.81343 21.1852 9.85303 21.9761V14.6097H7.17643V11.5625H9.85303V9.24001C9.85303 6.598 11.4268 5.13864 13.8348 5.13864C14.9881 5.13864 16.1945 5.34453 16.1945 5.34453V7.93877H14.8652C13.5557 7.93877 13.1473 8.75136 13.1473 9.58502V11.5625H16.071L15.6036 14.6097H13.1473V21.9761C18.1869 21.1852 22.0418 16.8241 22.0418 11.5625Z"
                                fill="#5374E5"
                            />
                        </svg>
                    </span>
                    Continue with Facebook
                </a>
                <LastUsedPill v-if="lastLoginMethod === 'facebook'" />
            </div>
            <div class="relative w-full">
                <a
                    class="w-full px-4 py-3 flex items-center gap-4 hover:opacity-50 transition-opacity rounded shadow border border-slate-200 font-semibold text-slate-800"
                    href="/login/google"
                >
                    <img
                        src="/images/google-g.svg"
                        width="22"
                        height="22"
                        alt="Sign in with Google"
                    />
                    Continue with Google
                </a>
                <LastUsedPill v-if="lastLoginMethod === 'google'" />
            </div>
            <div class="relative w-full">
                <a
                    class="w-full px-4 py-3 flex items-center gap-4 hover:opacity-50 transition-opacity rounded shadow border border-slate-200 font-semibold text-slate-800"
                    href="/login/apple"
                >
                    <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.579 11.5262C15.5678 9.70961 16.3851 8.35498 18.0366 7.35127C17.0899 5.98887 15.6398 5.24302 14.713 5.09834C13.5853 4.97793 12.4926 5.71039 11.9109 5.71039C11.2984 5.71039 10.3436 5.12832 9.42236 5.14648C8.19385 5.18281 7.05518 5.82305 6.42871 6.85449C5.10986 8.97266 6.09619 12.1274 7.35957 13.8379C7.99131 14.6773 8.73408 15.6173 9.7042 15.5825C10.5955 15.5443 10.9425 14.9963 12.0498 14.9963C13.1279 14.9963 13.4447 15.5825 14.3901 15.5614C15.3682 15.5443 16.0107 14.7167 16.6116 13.8691C17.0672 13.2271 17.4097 12.5193 17.6259 11.7695C16.5063 11.2986 15.579 10.2012 15.579 11.5262ZM13.8083 3.94385C14.3337 3.31396 14.6105 2.51611 14.5321 1.70996C13.7534 1.78994 12.9979 2.20234 12.4604 2.83521C11.9471 3.43994 11.637 4.2624 11.7268 5.04502C12.5616 5.06914 13.2596 4.60459 13.8083 3.94385Z"
                            fill="currentColor"
                        />
                    </svg>
                    Continue with Apple
                </a>
                <LastUsedPill v-if="lastLoginMethod === 'apple'" />
            </div>
        </div>
    </div>
</template>
<script setup>
import LastUsedPill from '@/components/auth/last-used-pill.vue';

defineProps({
    lastLoginMethod: {
        type: String,
        default: null,
    },
});
</script>
